import React, { useContext, useState } from "react";

import { DialogActions, Snackbar, Stack, Typography, } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";

import { BarraDeFerramentas } from "../../../Components/barra-de-ferramentas/BarraDeFerramentas";
import { func_print } from "../../../Func_genericas/func_print";
import { post } from "../../../Services/tokenConfig";
import { operacao_erro } from "../../../Func_genericas/valores_estaticos";
import { Alert } from "../../../Components/Alert/Alert";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../AuthContext/AuthContext";

interface IEficienciaProps {
  id_agri: number
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setflag_gerir_eficiencia: React.Dispatch<React.SetStateAction<boolean>>;
}

export const DialogNovaEficienciaAlimentar = ({
  id_agri,
  setIsLoading,
  setflag_gerir_eficiencia
}: IEficienciaProps) => {
  const auth = useContext(AuthContext);
  const navigate = useNavigate();
  const [message, setMessage] = React.useState("");
  const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
  const [openSnackError, setOpenSnackError] = React.useState(false);

  const [valueYear, setValueYear] = useState<Dayjs | null>(dayjs);

  const handleCreateCadernoEficiencia = async () => {
    try {
      let res = await post( auth.token.cookie_token,`/new_Tabela_ano_eficiencia`, {
        payload: {
          id_registo: 0,
          ano: valueYear?.format("YYYY"),
          id_agri: id_agri,

          id_identificacao: 0,
          last_update: new Date().toISOString(),
          create_date: new Date().toISOString(),
          uuid: "",
        },
      });

      if (res.status === 200) {
        setMessage("Criado com sucesso!")
        setflag_gerir_eficiencia(false);
        navigate("/EFIdentBenfExp",
          { state: res.data.result });
        setOpenSnackSuccess(true);
      } else {
        setMessage(operacao_erro)
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print("handleCreateCaderno", error, true);
      setMessage(operacao_erro)
      setOpenSnackError(true);
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Snackbar
          open={openSnackSuccess}
          autoHideDuration={2000}
          onClose={() => setOpenSnackSuccess(false)}
        >
          <Alert
            onClose={() => setOpenSnackSuccess(false)}
            severity="success"
            sx={{ width: "100%" }}
          >
            {message}
          </Alert>
        </Snackbar>
        <Snackbar
          open={openSnackError}
          autoHideDuration={2000}
          onClose={() => setOpenSnackError(false)}
        >
          <Alert
            onClose={() => setOpenSnackError(false)}
            severity="error"
            sx={{ width: "100%" }}
          >
            {message}

          </Alert>
        </Snackbar>
        <DialogActions>
          <Stack direction="column">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                views={["year"]}
                label={
                  <Typography fontFamily="candara" fontSize={18}>
                    Selecionar ano
                  </Typography>
                }
                value={valueYear}
                onChange={(valueYear) => {
                  setValueYear(valueYear);
                }}
                maxDate={dayjs()}
                minDate={dayjs("2020")}
              />
            </LocalizationProvider>
          </Stack>
        </DialogActions>
      </div>

      <Stack direction="row" display="flex" justifyContent="end" paddingTop={5}>
        <BarraDeFerramentas
          mostrarBotaoNovo
          aoClicarNovo={() => handleCreateCadernoEficiencia()}
          textoBotaoNovo="CRIAR"
        />
      </Stack>
    </>
  );
};
